// import React from "react";
// import { FaArrowUp } from "react-icons/fa";
// import './ScrollToTopButton.module.css'

// export default function ScrollToTopButton({ containerRef, isVisible }) {
//   const scrollToTop = () => {
//     containerRef.current.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
//     isVisible && (
//       <button className="scroll-to-top" onClick={scrollToTop}>
//         <FaArrowUp />
//       </button>
//     )
//   );
// }

import React from "react";
import { FaArrowUp } from "react-icons/fa";
import styles from './ScrollToTopButton.module.css'

export default function ScrollToTopButton({ containerRef, isVisible }) {
  const scrollToTop = () => {
    containerRef.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    isVisible && (
      
      <button className={styles["fab-scroll-top"]} onClick={scrollToTop}>
  <FaArrowUp />
</button>

    )
  );
}
